var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasRows)?_c('div',{staticStyle:{"margin-bottom":"24px"}},[(_vm.isProcessing)?_c('el-progress',{staticStyle:{"margin-bottom":"24px"},attrs:{"percentage":_vm.percent}}):_vm._e(),_c('el-alert',{attrs:{"closable":false,"type":_vm.alertType}},[(_vm.isProcessing)?_c('span',[_c('app-i18n',{attrs:{"code":"importer.noNavigateAwayMessage"}}),_vm._v("  ")],1):_vm._e(),_c('app-i18n',{attrs:{"args":[
        _vm.importedRowsCount,
        _vm.pendingRowsCount,
        _vm.errorRowsCount
      ],"code":"importer.total"}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }